<app-modal id="redirect-modal" [blocking]="true" #modalComponent>
  <div class="redirect-modal-container">
    <h2 class="font-h2">{{ "app.modal.redirect.title" | translate }}</h2>

    <p class="font-body2">{{ "app.modal.redirect.description" | translate }}</p>

    <div class="button-container">
      <app-button class="modal-button"
                  [label]="'app.modal.redirect.continue' | translate"
                  [buttonType]="'primary'"
                  fillParent="true"
                  (onClick)="redirect()"
                  [clickDelay]="1000"
                  gaTag="app.modal.redirect.continue"
      ></app-button>
      <app-button class="modal-button"
                  [label]="'app.modal.redirect.cancel' | translate"
                  [buttonType]="'secondary'"
                  fillParent="true"
                  (onClick)="close()"
                  [clickDelay]="1000"
                  gaTag="app.modal.redirect.cancel"
      ></app-button>
    </div>
  </div>
</app-modal>
